import { Typography } from '@mui/material';

import { JEBEL_ISOLOGO144 } from 'assets/images';
import { LoadingOverlay } from 'shared/components/ui';
import { useResponsive } from 'shared/hooks';

import {
  OnboardingLayoutContainer,
  OnboardingLayoutContent,
  OnboardingLayoutContentCard,
  OnboardingLayoutPoweredBy,
  OnboardingLayoutPoweredByImage,
  OnboardingLayoutSplashContainer,
  OnboardingLayoutSplashImage,
} from './OnboardingLayout.styles';

interface OnboardingLayoutProps {
  /** The URL of the splash image. */
  splashImage?: string;

  /** The title of the splash image. */
  splashImageTitle?: string;

  /** Whether the splash image is loading. */
  splashImageLoading?: boolean;

  children: React.ReactNode;
}

export function OnboardingLayout({
  splashImage,
  splashImageTitle,
  splashImageLoading,
  children,
}: OnboardingLayoutProps) {
  const { isTablet } = useResponsive();

  return (
    <OnboardingLayoutContainer>
      <OnboardingLayoutContent>
        <OnboardingLayoutContentCard>{children}</OnboardingLayoutContentCard>

        <OnboardingLayoutPoweredBy>
          <Typography color="textSecondary">Powered by</Typography>

          <OnboardingLayoutPoweredByImage src={JEBEL_ISOLOGO144} />
        </OnboardingLayoutPoweredBy>
      </OnboardingLayoutContent>

      {!isTablet && (
        <OnboardingLayoutSplashContainer>
          <LoadingOverlay loading={splashImageLoading}>
            <OnboardingLayoutSplashImage src={splashImage} alt={splashImageTitle} />
          </LoadingOverlay>
        </OnboardingLayoutSplashContainer>
      )}
    </OnboardingLayoutContainer>
  );
}
